import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// Client-side gate for UX only (redirect to /login) — this is NOT the
// real security boundary. The backend enforces the actual authorization
// on every request (e.g. GET /orders/{id} 403s a customer who doesn't
// own that order regardless of what this component does).
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, booting } = useAuth();
  const location = useLocation();

  if (booting) {
    return <div className="text-center py-16 text-sm text-neutral-500">Loading...</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
